import { useStores } from "api/stores";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { StoreForm } from "./StoreForm";

export function EditStore() {
  const { id: storeId } = useParams<{ id: string }>();
  const { useStoreData } = useStores();
  const { data: storeData } = useStoreData(storeId as string);
  const { message } = useMessage();

  return (
    <>
      <TopHeader
        title={storeData ? `${message({ id: "edit" })} ${storeData?.name}` : ""}
        clearLink={links.settings}
      />
      <div>
        <StoreForm editMode initialValues={storeData} />
      </div>
    </>
  );
}
